import React from 'react'
import { rewardDataStyle as styles } from "../redeemRewards.tailwind";

const RewardGaugeChart = ({ progress, totalPoints }) => {
  return (
    <div className={styles.gauge}>
        <svg className={styles.gauge__svg} viewBox="0 0 36 36" xmlns="http://www.w3.org/2000/svg">
            <circle cx="19" cy="18" r="16" fill="none" className={styles.gauge__circle_main} strokeWidth="2" strokeDasharray="50 100" strokeLinecap="round"></circle>
            <circle cx="19" cy="18" r="16" fill="none" className={styles.gauge__circle_percent}  strokeWidth="2" strokeDasharray={`${progress/2} 100`} strokeLinecap="round"></circle>
        </svg>
        <div className={styles.gauge_txt}>
            <span className={styles.gauge__value}>{progress}%</span>
            <span className={styles.gauge__label}><span className={styles.gauge_point}>{totalPoints}</span>Points</span>
        </div>
    </div>
  )
}

export default RewardGaugeChart